import DataProvider, { Store } from "./DataProvider";
import React from "react";
import { setTogglesFromBrowserGETParameter } from "app/toggleRouter";

/**
 * We initialize the toggle router here, since this module is (currently) used as main
 * module on any page. The toggles should be initialized before any rendering happens.
 */
setTogglesFromBrowserGETParameter();

export const PageDataProvider = ({ value, children }: { value: Store; children: any }) => {
    return <DataProvider value={value}>{children}</DataProvider>;
};
